





























































import {
  Component, Mixins,
} from 'vue-property-decorator';
import WinLoseData from '@/data/WinLoseData';
import Table from '@/components/Table/Index.vue';
import Pagination from '@/components/Pagination.vue';
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/store/modules/User';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import LogAdminBody from '@/components/Table/LogAdminBody.vue';

@Component({
  components: {
    Table,
    LogAdminBody,
    Pagination,
  },
})
export default class LogAdmin extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  UserInstance = getModule(UserModule, this.$store);

  criteria = {
    username: '',
    date: this.$moment().startOf('day').toDate(),
    limit: 100,
    isSelectPagination: false,
    amountPage: 1,
    dateId: '',
  };

  TableHeadLogAdmin = [...WinLoseData.TableHeadLogAdmin];

  data = {};

  isBet = true;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('YYYYMMDD'),
  }

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const { date } = this.criteria;
    this.criteria.dateId = this.$moment(date).format('YYYYMMDD');
    const { data, status } = this.isBet
      ? await this.UserInstance.GetBet(this.criteria)
      : await this.UserInstance.GetBetFailed(this.criteria);
    if (status.code) this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
    this.data = data;
  }

  changePage(i) {
    this.criteria.isSelectPagination = i !== 1;
    this.criteria.amountPage = i;
    this.onSubmit();
  }

  handleButton() {
    this.isBet = !this.isBet;
  }
}
